import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Moves focus to <main> on route change so screen readers announce the new page.
 * Also updates the document title for better browser tab UX.
 */
export function useFocusOnNavigate() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Move focus to main content area
    const main = document.getElementById('main-content');
    if (main) {
      main.focus({ preventScroll: true });
    }

    // Scroll to top on navigation
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
}
